export default "__VITE_ASSET__zOgcxzhJ__"